// FILECONTENT_START src/common/components/HtmlView/index.ts
import HtmlView from "./HtmlView";
export default HtmlView;
export type { HtmlViewProps } from "./HtmlView";

// FILECONTENT_END src/common/components/HtmlView/index.ts